import { validateWindowSize, updateLinksAttributes } from '../utils.js';

export const widgetName = 'slideshow6';

export default function slideshow6() {
  const widgetOpts = slideshow6Opts;
  const $widget = $(`#${widgetName}`);

  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $widget.html(swiperContainers);
      const { swiperImages, swiperContent } = initSwiper(response.Slides, widgetName);
      updateSwiper(swiperImages, swiperContent);
    }
  });
}

// Swiper Initialization
function initSwiper(widgetData, widgetName) {
  if (widgetData.length <= 1) {
    $(`#${widgetName} .content-wrap-inner`).addClass('single-slide');
  }

  const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);
  const swiperWidgetContentWrapper = $(`#${widgetName} .swiper-container-content .swiper-wrapper`);

  for (const slide of widgetData) {
    swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
    swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
  }

  const swiperImages = new Swiper(`#${widgetName} .swiper-container-images`, {
    speed: 600,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    loop: widgetData.length > 1,
    watchOverflow: true,
    spaceBetween: 0,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
    },
    a11y: true,
    autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: false,
    on: {
      init: function () {
        updateImageA11y(this);
      },
      slideChangeTransitionEnd: function () {
        updateImageA11y(this);
      },
    },
  });

  const swiperContent = new Swiper(`#${widgetName} .swiper-container-content`, {
    speed: 600,
    spaceBetween: 0,
    loop: widgetData.length > 1,
    watchOverflow: true,
    a11y: true,
    autoHeight: !validateWindowSize(1100),
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: `#${widgetName} .swiper-button-next`,
      prevEl: `#${widgetName} .swiper-button-prev`,
    },
    pagination: {
      el: `#${widgetName} .swiper-pagination`,
      clickable: true,
    },
    on: {
      init: function () {
        updateSlideA11y(this);
      },
      slideChangeTransitionEnd: function () {
        updateSlideA11y(this);
      },
    },
  });

  swiperImages.controller.control = swiperContent;
  swiperContent.controller.control = swiperImages;

  // Observer
  const sliderToObserve = document.querySelector(`#${widgetName} .swiper-container-images`);

  if (sliderToObserve) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.isIntersecting ? swiperImages.autoplay.start() : swiperImages.autoplay.stop();
        });
      },
      { threshold: 0.3 },
    );

    observer.observe(sliderToObserve);
  }

  return { swiperImages, swiperContent };
}

const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper"></div>
      <div class="swiper-pagination"></div>
    </div>

    <div class="content-wrap">
      <div class="content-wrap-inner">
        <div class="swiper-button-prev desktop-arrows"></div>
        <div class="swiper-container swiper-container-content">
          <div class="swiper-wrapper"></div>
        </div>
        <div class="swiper-button-next desktop-arrows"></div>
      </div>
    </div>    
  `;

// Slide Template - Images
function buildSlideTemplateImages(slide) {
  const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

  return template;
}

const buttonLabels = {
  moreLabel: 'More',
  purchaseLabel: 'Buy Now',
};

// buttons template
const buttons = function (btn1, btn2) {
  if (btn1 || btn2) {
    let btnContainer = $('<div class="button-container"></div>');
    if (btn1) {
      btnContainer.append(
        `<a href="${btn1}" class="button" ${updateLinksAttributes(btn1, buttonLabels.moreLabel)}>${buttonLabels.moreLabel}</a>`,
      );
    }
    if (btn2) {
      btnContainer.append(
        `<a href="${btn2}" class="button" ${updateLinksAttributes(btn2, buttonLabels.purchaseLabel)}>${buttonLabels.purchaseLabel}</a>`,
      );
    }
    return btnContainer.prop('outerHTML');
  } else {
    return '';
  }
};

// Slide Template - Content
function buildSlideTemplateContent(slide) {
  const template = `
      <div class="swiper-slide">
        <div class="swiper-content-container">
          <div class="wrap-content-slide">
            <h2 class="slide-title">${slide.Title}</h2>
          </div>
          ${buttons(slide.URL, slide.PurchaseURL)}
        </div>
      </div>
    `;

  return template;
}

function updateSwiper(swiperImages, swiperContent) {
  swiperImages.update();
  swiperContent.update();
}

// updating active slides content
function updateSlideA11y(swiper) {
  const $slides = $(swiper.slides);

  $slides.attr({
    'aria-selected': 'false',
    'aria-hidden': 'true',
    tabindex: '-1',
    inert: '',
  });

  $slides.find('a, button').attr('tabindex', '-1');

  const $active = $slides.filter('.swiper-slide-active');

  $active.removeAttr('inert').attr({
    'aria-selected': 'true',
    'aria-hidden': 'false',
    tabindex: '0',
  });

  $active.find('a, button').attr('tabindex', '0');
}

function updateImageA11y(swiper) {
  const $slides = $(swiper.slides);

  $slides.each(function (_, slide) {
    const $slide = $(slide);
    const isActive = $slide.hasClass('swiper-slide-active');

    $slide.attr('aria-hidden', isActive ? 'false' : 'true');
  });
}
